import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=1c8c93e3&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=1c8c93e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c93e3",
  null
  
)

export default component.exports